import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import BreadCrum from '../components/Breadcrum'
import ProductDisplay from '../components/ProductDisplay'
import DescriptionBox from '../components/DescriptionBox'
import RelatedProducts from '../components/RelatedProducts'

import { useDispatch, useSelector } from 'react-redux'
import { fetchSingleProduct } from '../redux/shopSlice'

const Product = () => {
  const productId = useParams().id;
  const dispatch = useDispatch();
  const { singleProduct, loading } = useSelector((state) => state.cart);

  useEffect(() => {
    if (productId) dispatch(fetchSingleProduct(productId));
  }, [productId, dispatch])

  return (
    <div>
      <BreadCrum product={singleProduct} loading={loading} />
      <ProductDisplay product={singleProduct} loading={loading} />
      <DescriptionBox product={singleProduct} loading={loading} />
      <RelatedProducts product={singleProduct} />
    </div>
  )
}

export default Product